export default __webpack_public_path__ + "static/media/cp_geo_il.4a6d7b98.svg";